import { getEditingToolByKey } from '../../utils/editingTools';
import type { SoftwareKey } from '../../types/file.types';

interface SoftwareCellProps {
  softwareKey: SoftwareKey;
}

export const SoftwareCell = ({ softwareKey }: SoftwareCellProps) => {
  const tool = getEditingToolByKey(softwareKey);
  const toolIcon = tool?.icon;
  const toolName = tool?.name;

  if (!toolIcon) {
    return <div className="flex h-10 items-center justify-center">-</div>;
  }

  return (
    <div className="flex h-10 items-center justify-center">
      <div
        className="relative flex h-8 w-8 items-center justify-center"
        data-tooltip-content={toolName}
        data-tooltip-id="tooltip"
        data-tooltip-place="top"
        data-tooltip-delay-show={100}
        data-tooltip-offset={5}
      >
        <img
          src={toolIcon}
          alt={toolName}
          className="h-6 w-6 object-contain"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
      </div>
    </div>
  );
};
